import React from 'react'

const B1BenefitsHead = () => {
  return (
    <div className="lvlBenefitsHead">
    <h2>Benefits of B1 Level German Course at <span>Prizma Academy</span></h2>
    <p>
      Elevate your German proficiency with our B1 Level German Course. Here's
      how it benefits you:
    </p>
  </div>
  )
}

export default B1BenefitsHead
